module.exports = __webpack_public_path__ + "resume.d13e84c3.pdf";